import script from "./GroupImgs.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupImgs.vue?vue&type=script&lang=ts&setup=true"

import "./GroupImgs.vue?vue&type=style&index=0&id=702e55e6&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-702e55e6"]])

export default __exports__